import { render, staticRenderFns } from "./UserPasswordLoginForm.vue?vue&type=template&id=79537724"
import script from "./UserPasswordLoginForm.vue?vue&type=script&lang=js"
export * from "./UserPasswordLoginForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports